import ResizeHandle from "./ResizeHandle"

import { Children } from "react"
import classNames from "classnames"

export default function Page({
  children,
  items,
  gridClasses,
  onMouseUp,
  onMoveMove,
  onMouseLeave,
  onDragStart,
  onDragEnd,
  rowHeightPx,
  onDragOver,
  onResizeHandleMouseDown,
  itemContainerClasses,
  canDragResize = true,
  showBottomBorder,
  canEdit,
  isDraggable = true,
}) {
  function getItemClass(item) {
    const itemWidth = item.width || "1"
    const itemHeight = item.height || "1"

    // xl:col-span-1
    // xl:col-span-2
    // xl:col-span-3
    // xl:col-span-4
    return classNames(
      "resizable-reorderable",
      itemContainerClasses,
      `xl:col-span-${itemWidth}`,
      `row-span-${itemHeight}`
    )
  }

  return (
    <div
      className={classNames("grid", gridClasses, {
        "border-b-4 border-dashed border-gray-300 pb-5": showBottomBorder,
      })}
      style={{ gridAutoRows: `${rowHeightPx}px` }}
      onMouseUp={onMouseUp}
      onMouseMove={onMoveMove}
      onMouseLeave={onMouseLeave}
    >
      {Children.map(children, (child, i) => {
        const item = items[i]

        // ensure item is re-rendered when size changes
        const itemKey = `${item.id}_${item.width}_${item.height}`

        return (
          <div
            id={item.gridIndex}
            key={itemKey}
            className={getItemClass(item)}
            draggable={canEdit && isDraggable}
            onDragStart={onDragStart}
            onDragEnd={onDragEnd}
            onDragOver={onDragOver}
          >
            {child}
            {canDragResize && (
              <ResizeHandle onResizeHandleMouseDown={onResizeHandleMouseDown} />
            )}
          </div>
        )
      })}
    </div>
  )
}
